import React, { useState } from "react";
import { trioMarkets, getTrioExposure, bookClass } from "./trioMarkets";
import Collapse from "../../../components/Collapse";
import { formatBook } from "../../../utils/formatOdds";

// Reference v-kvalmin / v-kvalmax: 1000 → K, 100000 → L
const kval = (n) => {
  const v = Number(Number(n || 0).toFixed(2));
  if (v >= 1e3 && v < 1e5) return `${parseFloat((v / 1e3).toFixed(2))}K`;
  if (v >= 1e5) return `${parseFloat((v / 1e5).toFixed(2))}L`;
  return String(parseFloat(v));
};

const isSuspended = (item) => String(item?.gstatus || "").toUpperCase() !== "OPEN";

/**
 * VBetTableTrio — V-Trio (vcasino/trio, .casino-table.vcasino.vtrio) odds in the reference markup:
 *   .main-odds (Session + 1 2 4 + J Q K), .other-odds (Two Red/Black/Odd/Even Only),
 *   .sub-odds (Pair, Flush, Straight, Trio, Straight Flush) — each a .vodds-box with
 *   .vrt17-odd-name (+ info icon / .icon-range collapse), .casino-bl-box, .odds-book.
 * Rendered as children of the page's .casino-detail.
 */
export default function VBetTableTrio({ data = [], onBetClick, exposures = {} }) {
  const m = trioMarkets(data, "v");
  const [openRange, setOpenRange] = useState(null);

  const click = (item, type) => {
    const value = type === "lay" ? item?.l : item?.b;
    if (isSuspended(item) || !value) return;
    onBetClick?.(value, item?.nat, type, item);
  };

  const range = (n, item) => {
    const id = `demo${n}`;
    const open = openRange === id;
    return (
      <div className="d-inline-block ml-2">
        <i
          data-toggle="collapse"
          data-target={`#${id}`}
          aria-expanded={open ? "true" : "false"}
          className={`fas fa-info-circle${open ? "" : " collapsed"}`}
          onClick={() => setOpenRange((p) => (p === id ? null : id))}
        />{" "}
        <Collapse id={id} open={!!open} className="icon-range">
          {"\n                                            R:"}
          <span>{kval(item?.min)}</span>-<span>{kval(item?.max)}</span>
        </Collapse>
      </div>
    );
  };

  const cell = (item, type) => (
    <div
      className={`${type} casino-bl-box-item${isSuspended(item) ? " suspended" : ""}`}
      onClick={() => click(item, type)}
    >
      <span className="casino-box-odd">{type === "lay" ? item?.l : item?.b}</span>
    </div>
  );

  const oddsBook = (item) => {
    const amt = getTrioExposure(exposures, item?.nat);
    return <div className={`w-100 odds-book text-center ${bookClass(amt)}`}>{formatBook(amt)}</div>;
  };

  const box = (n, item, withLay = true) => (
    <div className="vodds-box">
      <div className="vrt17-odd-name">
        {`\n                                    ${item?.nat ?? ""}\n                                    `}
        {range(n, item)}
      </div>{" "}
      <div className="casino-bl-box">
        {cell(item, "back")}
        {withLay && " "}
        {withLay && cell(item, "lay")}
      </div>{" "}
      {oddsBook(item)}
    </div>
  );

  const s = m.trio;

  return (
    <>
      <div className="main-odds">
        <div className="vodds-box">
          <div className="vrt17-odd-name">
            <b className="pointer">{s?.nat}</b> {range(0, s)}
          </div>{" "}
          <div className="casino-bl-box">
            <div
              className={`lay casino-bl-box-item${isSuspended(s) ? " suspended" : ""}`}
              onClick={() => click(s, "lay")}
            >
              <span className="casino-box-odd">{s?.l}</span> <span>{s?.lbhav}</span>
            </div>{" "}
            <div
              className={`back casino-bl-box-item${isSuspended(s) ? " suspended" : ""}`}
              onClick={() => click(s, "back")}
            >
              <span className="casino-box-odd">{s?.b}</span> <span>{s?.bbhav}</span>
            </div>
          </div>{" "}
          {oddsBook(s)}
        </div>{" "}
        {box(1, m.section124)} {box(2, m.jqk1)}
      </div>{" "}
      <div className="other-odds">
        {box(4, m.red2)} {box(5, m.black2)} {box(6, m.odd2)} {box(7, m.even2)}
      </div>{" "}
      <div className="sub-odds">
        {box(8, m.pair2, false)} {box(9, m.flush, false)} {box(10, m.straight, false)}{" "}
        {box(11, m.trio1, false)} {box(12, m.straightflush, false)}
      </div>
    </>
  );
}
